import { render } from "./EducationSection.vue?vue&type=template&id=4639fe6e&scoped=true"
import script from "./EducationSection.vue?vue&type=script&lang=js"
export * from "./EducationSection.vue?vue&type=script&lang=js"

import "./EducationSection.vue?vue&type=style&index=0&id=4639fe6e&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4639fe6e"]])

export default __exports__